import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VmeJobsComponent } from './vme-jobs.component';

const routes: Routes = [{ path: '', component: VmeJobsComponent, data: { title: 'Job List' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VmeJobsRoutingModule {}

@NgModule({
  imports: [
    VmeJobsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [VmeJobsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VmeJobsModule {}
